import {connect} from "react-redux";
import Grid from "../../grid";
import Popup from "../../popup";
import React from "react";
import Loader from "../../../atoms/loader";
import Button from "../../../atoms/button";
import TextInput from "../../../atoms/text-input";
import ButtonGroup from "../../button-group";
import ActionButton from "../../../atoms/action-button";
import NumberWidget from "../../number-widget";
import {handleTokenErrors} from "../../../../state/modules/errors";
import {checkoutCart, checkoutMollieCart, payOrder} from "../../../../state/modules/carts";
import {API_HOST, API_ROOT, http} from "../../../../util/http";
import {fetchActiveRegister} from "../../../../state/modules/register";

class CartCheckoutScreen extends React.Component {
    static defaultProps = {
        cart: null,
        createInvoice: false,
        onCancel: () => {
        },
        onSuccess: (method) => {
        },
        onFail: (message) => {
        },
        onHide: () => {
        }
    };
    
    constructor(props) {
        super(props);

        this.handlePayBound = this.handlePay.bind(this);
        this.completed = false;

        this.state = {
            createInvoice: props.createInvoice,
            loading: false,
            method: this.props.cart.has_pending_mollie_transaction ? 'mollie' : null,
            active: null,
            collected: {
                total: 0,
                discount: 0,
                cash: 0,
                mollie: 0,
            },
            received: {
                total: 0,
                cash: 0,
                mollie: 0,
            },
            remaining: this.props.cart.total - this.props.cart.total_collected_from_order,
            total_collected_from_order: this.props.cart.total_collected_from_order,
            has_pending_mollie_transaction: this.props.cart.has_pending_mollie_transaction,
            order_fully_paid: this.props.cart.order_fully_paid,
            paymentCheckInterval: null,
        }
    }
    
    componentDidMount() {
        if (this.props.cart.has_pending_mollie_transaction || this.props.cart.order_fully_paid) {
            this.checkStatus(true);
        }
        
        this.props.fetchActiveRegister();
    }
    
    componentWillUnmount() {
        this.clearPaymentCheck();
        document.removeEventListener("keyup", this.handlePayBound);
    }
    
    chooseCash() {
        if (this.props.cart.total === 0) {
            this.payCash();
            return;
        }
        
        document.addEventListener("keyup", this.handlePayBound);
        
        this.setState({
            method: 'cash',
            remaining: this.props.cart.total - this.state.total_collected_from_order,
        });
    }
    
    handlePay(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            
            this.payCash();
        }
    }
    
    payCash() {
        document.removeEventListener("keyup", this.handlePayBound);
        
        this.props
            .payOrder(this.props.cart.id, 'cash', this.state.createInvoice, this.state.received.cash)
            .then((response) => {
                if (!response.success) {
                    return;
                }
                
                if (!response.result.orderFullyPaid) {
                    this.setState({
                        collected: {
                            total: response.result.collected?.total,
                            cash: response.result.collected?.cash,
                            mollie: response.result.collected?.mollie,
                        },
                        received: {
                            cash: 0,
                            mollie: 0,
                        },
                        remaining: response.result.remaining,
                        total_collected_from_order: response.result.collected?.total,
                    });
                    
                    this.disableLoading();
                    
                    return;
                }
                
                if (this.completed) {
                    return;
                }
                this.completed = true;

                if (response.result.ticket && !this.props.activeRegister.location.disable_printer) {
                    this.props.onSuccess(response.result.ticket, response.result.giftcardPrintUrl);
                } else {
                    this.props.onSuccess(null, response.result.giftcardPrintUrl);
                }
            });
    }

    payCard() {
        this.props
            .payOrder(this.props.cart.id, 'card', this.state.createInvoice)
            .then((response) => {
                this.props.onSuccess(null, response.result?.giftcardPrintUrl);
            });
    }

    async payMollie() {
        this.enableLoading();
        
        this.setState({
            method: 'mollie',
        });
        
        await this.props.payOrder(this.props.cart.id, 'mollie', this.state.createInvoice, this.state.remaining)
            .then((response) => {
                if (!response.success) {
                    return;
                }
                
                this.checkStatus();
            })
            .catch(error => {
                handleTokenErrors(error);
                
                if (error.message === 'payment_failed') {
                    this.props.onFail('Payment failed');
                }
                
                this.disableLoading();
            })
    }
    
    createGiftcard() {
        this.props
            .payOrder(this.props.cart.id, 'giftcard', this.state.createInvoice)
            .then((response) => {
                if (!response.success) {
                    return;
                }

                this.props.onSuccess(response.result.ticket, response.result.giftcardPrintUrl);
            });
    }
    
    checkStatus(enableLoading = false) {
        if (enableLoading) {
            this.enableLoading();
        }
        
        this.paymentCheck();
    }
    
    paymentCheck() {
        let paymentCheckInterval = setInterval(() => {
            http
                .request({url: API_HOST + API_ROOT + 'carts/' + this.props.cart.id + '/checkout-status'}, true)
                .then(response => {
                    this.setState({
                        has_pending_mollie_transaction: response.result.has_pending_mollie_transaction,
                    })
                    
                    if (response.result.has_pending_mollie_transaction) {
                        return;
                    }
                    
                    if (response.result.status === 1) {
                        this.clearPaymentCheck();

                        if (this.completed) {
                            return;
                        }
                        this.completed = true;

                        const sound = new Audio(process.env.PUBLIC_URL + 'mp3/kaching.mp3');
                        sound.play();

                        if (this.props.activeRegister?.location.disable_printer) {
                            this.props.onSuccess(null, response.result.giftcardPrintUrl);
                            return;
                        }

                        this.props.onSuccess(response.result.ticket, response.result.giftcardPrintUrl);
                        return;
                    }
                    
                    if (response.result.status === 2) {
                        this.props.onFail('Payment cancelled');
                    }
                    
                    if (response.result.status === 3) {
                        this.props.onFail('Payment failed');
                    }
                    
                    if (response.result.status === 4) {
                        this.props.onFail('Payment expired');
                    }
                    
                    this.clearPaymentCheck();

                    this.disableLoading();
                })
                .catch(error => {
                    // Stop polling on a hard failure so the checkout can't hang forever.
                    this.clearPaymentCheck();
                    this.disableLoading();
                    handleTokenErrors(error);
                });
        }, 1000);
        
        this.setState({
            paymentCheckInterval: paymentCheckInterval
        });
    }
    
    clearPaymentCheck() {
        if (!this.state.paymentCheckInterval) {
            return;
        }
        
        clearInterval(this.state.paymentCheckInterval);
        
        this.setState({
            paymentCheckInterval: null,
        });
    }
    
    enableLoading() {
        this.setState({
            loading: true,
        });
    }
    
    disableLoading() {
        this.setState({
            loading: false,
            method: null,
        });
    }
    
    handleCancel() {
        if (!this.state.method) {
            this.props.onCancel();
        }
        
        this.disableLoading();
    }
    
    handleHide() {
        this.props.onHide();
    }
    
    render() {
        let footer = (
            <ButtonGroup>
                {!this.state.loading && !this.state.method && (
                    <Button text={'Cancel order'} modifiers={'alt'} onClick={this.handleCancel.bind(this)}/>
                )}
                {this.state.method && this.state.method !== 'mollie' && (
                    <Button text={'Cancel'} modifiers={'alt'} onClick={this.handleCancel.bind(this)}/>
                )}
                {this.state.method === 'cash' && (
                    <Button text={'Pay'} onClick={event => {
                        this.payCash();
                    }}/>
                )}
            </ButtonGroup>
        );
        
        const receivedCash = this.state.received.cash;
        
        return (
            <Popup
                title={'Cart #' + this.props.cart.id}
                footer={footer}
                closable={!this.state.loading}
                hideable={!this.state.order_fully_paid && (this.state.method || this.state.has_pending_mollie_transaction)}
                onClose={this.handleCancel.bind(this)}
                onHide={this.handleHide.bind(this)}
            >
                <Grid>
                    <Grid modifiers={'padded'}>
                        <NumberWidget
                            prefix={'€'}
                            value={this.props.cart.total.toFixed(2)}
                            title={'Order total'}
                        />
                        {this.props.cart.total > 0 && (
                            <Grid modifiers={'padded'}>
                                <NumberWidget
                                    prefix={'€'}
                                    value={(this.state.total_collected_from_order).toFixed(2) }
                                    title={'Received'}
                                    modifiers={'success'}
                                />
                                <NumberWidget
                                    prefix={'€'}
                                    value={this.state.remaining?.toFixed(2)}
                                    title={this.state.remaining > 0 ? 'Remaining' : 'Change'}
                                    modifiers={this.state.remaining > 0 ? 'warning' : 'success'}
                                />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
                
                {this.props.cart.total >= 0 && !this.state.method && !this.state.loading && (
                    <Grid cols={'1fr 1fr'}>
                        <ActionButton modifiers={'xl'} text={'Pay Mollie'} onClick={this.payMollie.bind(this)}/>
                        <ActionButton modifiers={'xl'} text={'Pay cash'} onClick={this.chooseCash.bind(this)}/>
                    </Grid>
                )}
                
                {this.props.cart.total < 0 && (
                    <Grid cols={'1fr 1fr'}>
                        <ActionButton modifiers={'xl'} text={'Create Giftcard'} onClick={this.createGiftcard.bind(this)}/>
                        <ActionButton modifiers={'xl'} text={'Choose cash'} onClick={this.payCash.bind(this)}/>
                    </Grid>
                )}
                
                {this.state.method === 'cash' && (
                    <div className="content-loader">
                        <TextInput
                            modifiers={'big'}
                            name="received"
                            label="Received"
                            type="number"
                            showRequiredIndicator={true}
                            focus={true}
                            onChange={(value) => {
                                value = parseFloat(value.toString().replace(',', '.'));
                                
                                if (isNaN(value)) {
                                    value = 0
                                }
                                
                                this.setState({
                                    received: {
                                        cash: value
                                    },
                                    remaining: this.props.cart.total - this.state.total_collected_from_order - value,
                                });
                            }}
                        />
                    </div>
                )}
                
                {this.state.loading && (
                    <div className="content-loader">
                        <Loader isLoading={true} size="large"/>
                    </div>
                )}
            </Popup>
        );
    }
}

const mapStateToProps = (state) => ({
    carts: state.carts.carts,
    lists: state.resources.lists,
    activeRegister: state.register.activeRegister,
});

const mapDispatchToProps = {
    payOrder: payOrder,
    checkoutCart: checkoutCart,
    checkoutMollieCart: checkoutMollieCart,
    fetchActiveRegister: fetchActiveRegister,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartCheckoutScreen);